<template lang="pug">
div
    Button(@click="toggleSelectAll" v-if="withSelectAllBtn") select all
    h3(v-if="tableData.length == 0" style="text-align: center; margin: 50px;") {{ noDataText }}
    vue-virtual-table(v-else :config="tableConfig" :data="tableData" :minWidth="minWidth")
        template(slot-scope="scope" slot="selection")
            Checkbox(
                v-model="scope.row._checked"
                @on-change="(...args) => { select(scope.index, ...args); }"
            )
    // p(v-for="item in selectedItems") {{ item }}
</template>

<script>
import VueVirtualTable from "vue-virtual-table";

export default {
    name: "VirtualTable",
    components: {
        VueVirtualTable
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
        columns: {
            type: Array,
            default: () => []
        },
        minWidth: {
            type: Number,
            default: 1200
        },
        withSelectAllBtn: {
            type: Boolean,
            default: true
        },
        noDataText: {
            type: String,
            default: "No Data"
        }
    },
    watch: {
        data: function(newVal, oldVal) {
            this.mapData();
        }
    },
    data() {
        return {
            tableConfig: [],
            tableData: []
        };
    },
    mounted() {
        this.mapColumns();
        this.mapData();
    },
    methods: {
        mapColumns() {
            this.tableConfig = this.columns.map(e => ({
                prop: e.key,
                name: e.title,
                width: e.width,
                sortable: e.sortable || false
            }));
            if (this.columns.some(e => e.type == "selection")) {
                this.tableConfig.unshift({
                    prop: "_action",
                    name: "#",
                    width: 60,
                    actionName: "selection"
                });
            }
            this.tableConfig = this.tableConfig.filter(e => e.prop !== undefined);
        },
        mapData() {
            this.tableData = this.data.map(e => {
                e._checked = false;
                return e;
            });
        },
        toggleSelectAll() {
            let hasSelect = this.tableData.some(e => e._checked);
            let selectedItems = this.getSelection();
            let isAllSelected = selectedItems.length == this.tableData.length;
            this.tableData = this.tableData.map(e => {
                e._checked = !isAllSelected;
                return e;
            });

            this.$emit("on-selection-change", this.getSelection());
        },
        select(index, val) {
            // 直接附值資料會更新, 但不會更新渲染
            // this.tableData[index]._checked = val;
            this.tableData = this.tableData.map((e, i) => {
                if (index == i) e._checked = val;
                return e;
            });
            let selectedItems = this.getSelection();
            this.$emit("on-selection-change", selectedItems);
        },
        getSelection() {
            return this.tableData.filter(e => e._checked);
        }
    },
    computed: {}
};
</script>

<style>
.list {
    border: 2px solid steelblue;
    border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/VirtualTable.vue